import { createAction, props } from '@ngrx/store';

export const paginateInterestForm = createAction(
  '[ INTEREST_FORM ] Paginating'
);

export const loadInterestForms = createAction(
  '[ INTEREST_FORM ] Loading',
  props<{ payload: any[], key: string, totalDocuments: number }>()
);

export const changeInterestFormStatus = createAction(
  '[ INTEREST_FORM ] Change Interest Form Status',
  props<{ ids: any[], key: string, status: string }>()
);

export const assignExecutiveToInterestForm = createAction(
  '[ INTEREST_FORM ] Assign Executive To Interest Form',
  props<{ ids: any[], key: string, payload: any }>()
);

export const clearAllInterestForms = createAction(
  '[ INTEREST_FORM ] Clear',
  props<{ key: string }>()
);

export const clearInterestForms = createAction(
  '[ INTEREST_FORM ] Delete Lead',
  props<{ payload: string[], key: string }>()
);
